import React, { useState, useEffect } from 'react';
import SearchableSelect from './SearchableSelect';
import './VehicleStatistic.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://apiqldangkyxe.nguyenluan.vn';

const VehicleStatisticForm = ({ vehicleCategory, initialData, onSave, onCancel, user, units }) => {
  const [existingImages, setExistingImages] = useState([]);
  const [newImageFiles, setNewImageFiles] = useState([]);
  const [newImagePreviews, setNewImagePreviews] = useState([]);
  const [previewImageUrl, setPreviewImageUrl] = useState(null);
  const [formData, setFormData] = useState({
    licensePlate: '',
    ownerNamePhone: '',
    ownerAddress: '',
    currentUserNamePhone: '',
    currentUserAddress: '',
    driverNamePhone: '',
    driverAddress: '',
    origin: '',
    collectorNameAndUnit: '',
    collectorName: '',
    collectorUnitId: '',
    notes: '',
    plateColor: '',
    hasMonitoringDevice: false,
    monitoringAccount: '',
    monitoringPassword: '',
    monitoringProvider: '',
    isModified: '',
    isExtended: '',
    platePosition: '',
    hasModifiedLightsHorn: '',
    usageExpiry: '',
    registeredSeats: '',
    actualSeats: '',
    modificationSigns: '',
    businessSigns: '',
    hasYellowPlate: false,
    infoSource: '',
    vehicleBrand: '',
    ownershipStatus: '',
    usageStatus: '',
  });

  useEffect(() => {
    if (initialData) {
      let cName = '';
      if (initialData.collectorNameAndUnit) {
        cName = initialData.collectorNameAndUnit.split(' / ')[0] || '';
      }
      setFormData({
        ...formData,
        ...initialData,
        collectorName: cName,
        collectorUnitId: initialData.unitId || ''
      });
      if (initialData.sceneImage) {
        try {
          const imgs = JSON.parse(initialData.sceneImage);
          if (Array.isArray(imgs)) setExistingImages(imgs);
        } catch (e) { }
      }
    } else {
      // Khi thêm mới, nếu không phải admin thì lấy unitId của user hiện tại
      setFormData(prev => ({
        ...prev,
        collectorUnitId: (user && user.role !== 'admin' && user.role !== 'supervisor') ? user.unitId : ''
      }));
    }
  }, [initialData, user]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setNewImageFiles(prev => [...prev, ...files]);
      const newPreviews = files.map(file => URL.createObjectURL(file));
      setNewImagePreviews(prev => [...prev, ...newPreviews]);
    }
  };

  const removeExistingImage = (index) => {
    setExistingImages(prev => prev.filter((_, i) => i !== index));
  };

  const removeNewImage = (index) => {
    setNewImageFiles(prev => prev.filter((_, i) => i !== index));
    setNewImagePreviews(prev => prev.filter((_, i) => i !== index));
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const submitData = { ...formData };

    let unitName = '';
    if (user && (user.role === 'admin' || user.role === 'supervisor')) {
      const selectedUnit = units?.find(u => u.id.toString() === formData.collectorUnitId.toString());
      unitName = selectedUnit ? selectedUnit.name : '';
    } else {
      unitName = user?.unit?.name || 'Đơn vị';
    }
    submitData.collectorNameAndUnit = `${formData.collectorName} / ${unitName}`;
    submitData.unitId = formData.collectorUnitId;

    onSave(submitData, newImageFiles, existingImages);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content vehicle-statistic-form-modal">
        <div className="modal-header">
          <h3>
            {initialData ? 'Cập nhật' : 'Thêm mới'} thống kê -{' '}
            {vehicleCategory === 'DUMP_TRUCK'
              ? 'Ô tô tải tự đổ'
              : vehicleCategory === 'LIMOUSINE'
                ? 'Xe Limousine'
                : vehicleCategory === 'PASSENGER_NO_YELLOW'
                  ? 'Xe KDVT khách chưa đổi biển vàng'
                  : 'Mô tô công nhân KCN'}
          </h3>
          <button className="btn-close" onClick={onCancel}>
            &times;
          </button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              {/* --- SHARED FIELDS --- */}
              <div className="form-group full-width">
                <label>Biển số (*)</label>
                <input
                  type="text"
                  name="licensePlate"
                  value={formData.licensePlate}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Tên chủ sở hữu / SĐT (*)</label>
                <input
                  type="text"
                  name="ownerNamePhone"
                  value={formData.ownerNamePhone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Địa chỉ chủ sở hữu (*)</label>
                <input
                  type="text"
                  name="ownerAddress"
                  value={formData.ownerAddress}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Tên người đang sử dụng / SĐT (*)</label>
                <input
                  type="text"
                  name="currentUserNamePhone"
                  value={formData.currentUserNamePhone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Địa chỉ người sử dụng (*)</label>
                <input
                  type="text"
                  name="currentUserAddress"
                  value={formData.currentUserAddress}
                  onChange={handleChange}
                  required
                />
              </div>

              {vehicleCategory !== 'PASSENGER_NO_YELLOW' && (
                <>
                  <div className="form-group">
                    <label>Tên người điều khiển / SĐT (*)</label>
                    <input
                      type="text"
                      name="driverNamePhone"
                      value={formData.driverNamePhone}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Địa chỉ người điều khiển (*)</label>
                    <input
                      type="text"
                      name="driverAddress"
                      value={formData.driverAddress}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </>
              )}

              <div className="form-group">
                <label>
                  {vehicleCategory === 'PASSENGER_NO_YELLOW' || vehicleCategory === 'WORKER_MOTO'
                    ? 'Nguồn gốc xe (mua ở đâu, của ai, địa chỉ) (*)'
                    : 'Nguồn gốc mua xe (mua ở đâu, của ai, địa chỉ) (*)'}
                </label>
                <input
                  type="text"
                  name="origin"
                  value={formData.origin}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* --- TYPE 1: DUMP TRUCK --- */}
              {vehicleCategory === 'DUMP_TRUCK' && (
                <>
                  <div className="form-group">
                    <label>Hoán cải phương tiện (*)</label>
                    <input
                      type="text"
                      name="isModified"
                      value={formData.isModified}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Cơi nới thành thùng (*)</label>
                    <input
                      type="text"
                      name="isExtended"
                      value={formData.isExtended}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Vị trí lắp biển số (*)</label>
                    <input
                      type="text"
                      name="platePosition"
                      value={formData.platePosition}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Độ chế còi đèn (*)</label>
                    <input
                      type="text"
                      name="hasModifiedLightsHorn"
                      value={formData.hasModifiedLightsHorn}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Niên hạn sử dụng (*)</label>
                    <input
                      type="text"
                      name="usageExpiry"
                      value={formData.usageExpiry}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </>
              )}

              {/* --- TYPE 1 & 2 SHARED --- */}
              {(vehicleCategory === 'DUMP_TRUCK' || vehicleCategory === 'LIMOUSINE') && (
                <>
                  <div className="form-group">
                    <label>Màu biển (*)</label>
                    <select
                      name="plateColor"
                      value={formData.plateColor}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Chọn màu biển --</option>
                      <option value="Nền màu trắng, chữ và số màu đen">Nền màu trắng, chữ và số màu đen</option>
                      <option value="Nền màu vàng, chữ và số màu đen">Nền màu vàng, chữ và số màu đen</option>
                      <option value="Nền màu xanh, chữ và số màu trắng">Nền màu xanh, chữ và số màu trắng</option>
                    </select>
                  </div>
                  <div className="form-group full-width">
                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                      <input
                        type="checkbox"
                        name="hasMonitoringDevice"
                        checked={formData.hasMonitoringDevice}
                        onChange={handleChange}
                        style={{ marginRight: '8px', width: 'auto' }}
                      />
                      Có thiết bị giám sát hành trình và ghi nhận hình ảnh
                    </label>
                  </div>
                  {formData.hasMonitoringDevice && (
                    <div className="monitoring-device-details full-width form-grid" style={{ backgroundColor: '#eff6ff', border: '2px dashed #3b82f6', padding: '15px', borderRadius: '8px', marginTop: '10px' }}>
                      <div className="form-group">
                        <label>Tài khoản GSHT (*)</label>
                        <input
                          type="text"
                          name="monitoringAccount"
                          value={formData.monitoringAccount}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Mật khẩu GSHT (*)</label>
                        <input
                          type="text"
                          name="monitoringPassword"
                          value={formData.monitoringPassword}
                          onChange={handleChange}
                          required
                        />
                      </div>
                      <div className="form-group full-width">
                        <label>Đơn vị cung cấp (*)</label>
                        <input
                          type="text"
                          name="monitoringProvider"
                          value={formData.monitoringProvider}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* --- TYPE 2: LIMOUSINE --- */}
              {vehicleCategory === 'LIMOUSINE' && (
                <>
                  <div className="form-group">
                    <label>Số chỗ theo kiểm định (*)</label>
                    <input
                      type="text"
                      name="registeredSeats"
                      value={formData.registeredSeats}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Số chỗ thực tế (*)</label>
                    <input
                      type="text"
                      name="actualSeats"
                      value={formData.actualSeats}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group full-width">
                    <label>Dấu hiệu cải tạo (*)</label>
                    <input
                      type="text"
                      name="modificationSigns"
                      value={formData.modificationSigns}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </>
              )}

              {/* --- TYPE 3: PASSENGER_NO_YELLOW --- */}
              {vehicleCategory === 'PASSENGER_NO_YELLOW' && (
                <>
                  <div className="form-group">
                    <label>Dấu hiệu KDVT (*)</label>
                    <input
                      type="text"
                      name="businessSigns"
                      value={formData.businessSigns}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Đã đổi biển vàng (*)</label>
                    <select
                      name="hasYellowPlate"
                      value={formData.hasYellowPlate}
                      onChange={(e) => handleChange({ target: { name: 'hasYellowPlate', value: e.target.value === 'true' } })}
                      required
                    >
                      <option value="false">Chưa</option>
                      <option value="true">Rồi</option>
                    </select>
                  </div>
                  <div className="form-group full-width">
                    <label>Nguồn thông tin rà soát (*)</label>
                    <input
                      type="text"
                      name="infoSource"
                      value={formData.infoSource}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </>
              )}

              {/* --- TYPE 4: WORKER_MOTO --- */}
              {vehicleCategory === 'WORKER_MOTO' && (
                <>
                  <div className="form-group">
                    <label>Loại xe / Nhãn hiệu (*)</label>
                    <input
                      type="text"
                      name="vehicleBrand"
                      value={formData.vehicleBrand}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Tình trạng phương tiện (*)</label>
                    <select
                      name="ownershipStatus"
                      value={formData.ownershipStatus}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Chọn tình trạng --</option>
                      <option value="Chính chủ">Chính chủ</option>
                      <option value="Không chính chủ">Không chính chủ</option>
                    </select>
                  </div>
                  <div className="form-group full-width">
                    <label>Thực trạng quản lý sử dụng (Gương chiếu hậu, biển mờ, độ chế...) (*)</label>
                    <textarea
                      name="usageStatus"
                      value={formData.usageStatus}
                      onChange={handleChange}
                      rows="3"
                      required
                    ></textarea>
                  </div>
                </>
              )}

              {/* --- SHARED END FIELDS --- */}
              <div className="form-group">
                <label>Họ tên cán bộ thu thập (*)</label>
                <input
                  type="text"
                  name="collectorName"
                  value={formData.collectorName}
                  onChange={handleChange}
                  required
                />
              </div>

              {(user?.role === 'admin' || user?.role === 'supervisor') && (
                <div className="form-group">
                  <label>Đơn vị công tác (*)</label>
                  <SearchableSelect
                    options={[
                      { value: '', label: '-- Chọn đơn vị --' },
                      ...(units || []).map(unit => ({ value: unit.id, label: unit.name }))
                    ]}
                    value={formData.collectorUnitId}
                    onChange={(val) => setFormData(prev => ({ ...prev, collectorUnitId: val }))}
                    placeholder="-- Chọn đơn vị --"
                  />
                </div>
              )}

              <div className="form-group full-width">
                <label>Ghi chú (*)</label>
                <textarea
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  rows="3"
                  required
                ></textarea>
              </div>

              <div className="form-group full-width">
                <label>Ảnh hiện trường (Có thể chọn nhiều ảnh hoặc chụp nhiều lần)</label>
                <input
                  type="file"
                  accept="image/*"
                  capture="environment"
                  multiple
                  onChange={handleImageChange}
                  style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '4px', width: '100%', marginBottom: '10px' }}
                />

                {(existingImages.length > 0 || newImagePreviews.length > 0) && (
                  <div style={{ marginTop: '10px' }}>
                    <p style={{ margin: '0 0 5px 0', fontSize: '13px', color: '#6b7280' }}>Xem trước:</p>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                      {existingImages.map((imgUrl, index) => (
                        <div key={`existing-${index}`} style={{ position: 'relative' }}>
                          <img
                            src={imgUrl.startsWith('http') ? imgUrl : `${API_BASE_URL}${imgUrl}`}
                            alt="Ảnh cũ"
                            onClick={() => setPreviewImageUrl(imgUrl.startsWith('http') ? imgUrl : `${API_BASE_URL}${imgUrl}`)}
                            style={{ width: '80px', height: '80px', borderRadius: '4px', border: '1px solid #e5e7eb', objectFit: 'cover', cursor: 'pointer' }}
                          />
                          <button
                            type="button"
                            onClick={() => removeExistingImage(index)}
                            style={{ position: 'absolute', top: '-5px', right: '-5px', background: 'red', color: 'white', border: 'none', borderRadius: '50%', width: '20px', height: '20px', minWidth: '20px', minHeight: '20px', padding: 0, cursor: 'pointer', fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                          >×</button>
                        </div>
                      ))}
                      {newImagePreviews.map((preview, index) => (
                        <div key={`new-${index}`} style={{ position: 'relative' }}>
                          <img
                            src={preview}
                            alt="Ảnh mới"
                            onClick={() => setPreviewImageUrl(preview)}
                            style={{ width: '80px', height: '80px', borderRadius: '4px', border: '2px solid #3b82f6', objectFit: 'cover', cursor: 'pointer' }}
                          />
                          <button
                            type="button"
                            onClick={() => removeNewImage(index)}
                            style={{ position: 'absolute', top: '-5px', right: '-5px', background: 'red', color: 'white', border: 'none', borderRadius: '50%', width: '20px', height: '20px', minWidth: '20px', minHeight: '20px', padding: 0, cursor: 'pointer', fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                          >×</button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="modal-actions">
              <button type="button" className="btn-cancel" onClick={onCancel}>
                Hủy
              </button>
              <button type="submit" className="btn-primary">
                Lưu lại
              </button>
            </div>
          </form>
        </div>
      </div>

      {previewImageUrl && (
        <div
          className="modal-overlay"
          style={{ zIndex: 10000, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.8)' }}
          onClick={() => setPreviewImageUrl(null)}
        >
          <div style={{ position: 'relative', maxWidth: '90%', maxHeight: '90%' }}>
            <button
              onClick={() => setPreviewImageUrl(null)}
              style={{ position: 'absolute', top: '-15px', right: '-15px', background: 'red', color: 'white', border: 'none', borderRadius: '50%', width: '30px', height: '30px', cursor: 'pointer', fontSize: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10001 }}
            >×</button>
            <img
              src={previewImageUrl}
              alt="Preview"
              style={{ maxWidth: '100%', maxHeight: '90vh', objectFit: 'contain', borderRadius: '4px' }}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default VehicleStatisticForm;
